
import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { config } from "../../../CommonUtils/CommonUrl/CommonUrls";
import Header from "../../../Header/Header";
import { CommonAxiosGet } from "../../../CommonUtils/CommonAxios/CommonAxios";
import { alertMessage } from "../../../CommonUtils/CommonPopupAndAlerts/SweetAlerts";
export default function ACLMappedReport() {

  let navigate = useNavigate();
  const location = useLocation();
  const data = location?.state?.data;
  const [AcloData, setAcloData] = useState([]);
  function ACLOMandals() {
    const URLL = `${config.url.BOC_URL}alos/${data?.distcode}/${data?.org_id}`;
    CommonAxiosGet(URLL).then((response) =>  {  
      if (response?.data.status === true) {
        setAcloData(response?.data.alcoMandals);
      }
    });
  }
  useEffect(() => {
    ACLOMandals();
  }, []);
  return (
    <>
      <Header />
      <div className="main_section"> </div>
     
          <Container>
            <Row>
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                xxl={12}
                className="page-titlespacing d-flex justify-content-between"
              >
                <div className="inner-herbpage-service-title1">
                <h1> 
                <span style={{color:"brown"}}>{data.org_name}</span> - ALO Mapping Report</h1>
                </div>
                <div className="text-right">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={()=>{ navigate(-1);}}
                  >
                    Back
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
          <Container className="outer-page-content-container">
            <Row className="px-4">
              <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
                                        style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }}
                                    >
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>ALO Name</th>
                    <th>No Of Mapped Mandals</th>
                  </tr>
                </thead>
                <tbody>
                  {AcloData &&
                    AcloData?.map((data, i) => {
                      return (
                        <tr key={i}>
                          <td style={{ textAlign: "center" }}>{i + 1}</td>
                          <td>{data.org_name}</td>
                          <td style={{ textAlign: "center" ,color:"Highlight",textDecoration:"underline"}} onClick={() => {
                                data.no_of_mandals_mapped !== 0
                                  ? navigate("/AloMappedMandalsReport",{state : {data:data}}) 
                                  : alertMessage();
                              }}>
                              {data.no_of_mandals_mapped}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </Row>
          </Container>
    </>
  );
}
